import React, { useContext } from "react";
import { HeaderContext } from "../NwHeader";
import GlobalSearchWrapperManagement from "./GlobalSearchWrapperManagement";
import GlobalSearchWrapperAccounting from "./GlobalSearchWrapperAccounting";
import GlobalSearchWrapperBooking from "./GlobalSearchWrapperBooking";

const GlobalSearchByArea = () => {
    const headerContextValues = useContext(HeaderContext);
    const { area } = headerContextValues;
    
    switch (area) {
        case 'art':
            return null;
        case 'management':
            return <GlobalSearchWrapperManagement />;
        case 'accounting':
            return <GlobalSearchWrapperAccounting />;
        default:
            return <GlobalSearchWrapperBooking />;
    }
}

export default GlobalSearchByArea;
